import DateTimeSelect from 'commons/js/ui/DateTimeSelect'
import React from 'react'
import styled from 'styled-components'
import {
    themeFontSize,
} from '@elparking/components'

const DateTimeSelectWrapper = styled.div`
    ${DateTimeSelect} {
        width: 100%;
        border: none;
        padding-left: 0;
        padding: 1em;
        input {
            font-size: ${themeFontSize('small')};
        }
        label {
        padding: 0;
        }
    }
`

const Wrapped = React.forwardRef((props, ref) =>
    <DateTimeSelectWrapper>
        <DateTimeSelect ref={ref} {...props} />
    </DateTimeSelectWrapper>
)

export default Wrapped
